'use client';

import type { CroppedImage } from '@baseball-near-you/common';
import { useState } from 'react';
import { ImageCropper } from '../image-cropper';
import { ImageDropzone } from '../image-dropzone';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui';

export function ImageUpload(props: {
  setCroppedImage: (image: CroppedImage | null) => Promise<void>;
  onCropComplete: () => void;
  isEditing?: boolean;
  aspectRatios?: { width: number; height: number }[];
  imageSaving: boolean;
}) {
  const [file, setFile] = useState<File | null>(null);
  const [opened, setOpened] = useState(false);

  return (
    <Dialog
      open={opened}
      onOpenChange={(open) => {
        setOpened(open);
        if (!open) {
          props.setCroppedImage(null);
        }
      }}
    >
      <DialogTrigger asChild>
        <Button
          type="button"
          onClick={() => setOpened(true)}
          className="w-full"
          variant={file ? 'outline' : 'default'}
        >
          {file ? 'Change image' : 'Upload image'}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Upload an image</DialogTitle>
        </DialogHeader>
        <div className="flex min-h-[8rem] w-full items-center justify-center">
          {!file ? (
            <ImageDropzone
              onDrop={(files) => {
                if (files) {
                  setFile(files[0]);
                  setOpened(true);
                }
              }}
            />
          ) : (
            <ImageCropper
              imageSaving={props.imageSaving}
              aspectRatios={props.aspectRatios}
              onCrop={async (image, name, type) => {
                // something with the image
                await props.setCroppedImage({
                  image,
                  name: name.split('.')[0],
                  type,
                });
                props.onCropComplete();
                setOpened(false);
              }}
              open={opened}
              onClose={() => setOpened(false)}
              image={file}
              onReset={() => {
                setFile(null);
              }}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
